/* Claude structure draft: desktop dropdowns open on hover AND click.
   - Only for a fine pointer that can hover, at desktop width (990px+).
   - Touch devices keep Dawn's tap-to-expand.
   - Keyboard keeps Dawn's Enter/Space to toggle, Escape to close.
   - A short close delay lets the pointer move into the dropdown.
   - Plain links are untouched. */
(function () {
  var CLOSE_DELAY = 300;
  var mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');

  function setOpen(d, open) {
    var s = d.querySelector('summary');
    if (open) { d.setAttribute('open', ''); } else { d.removeAttribute('open'); }
    if (s) s.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeOthers(keep) {
    document.querySelectorAll('.header__inline-menu details[open]').forEach(function (o) {
      if (o !== keep) setOpen(o, false);
    });
  }

  function init() {
    document.querySelectorAll('.header__inline-menu .list-menu--inline > li details').forEach(function (d) {
      if (d.dataset.claudeHover) return;
      d.dataset.claudeHover = '1';
      var li = d.closest('li') || d;
      var timer = null;
      var openedByHover = false;

      li.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        clearTimeout(timer);
        closeOthers(d);
        if (!d.hasAttribute('open')) {
          setOpen(d, true);
          openedByHover = true;
        }
      });

      li.addEventListener('mouseleave', function () {
        if (!mq.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () {
          setOpen(d, false);
          openedByHover = false;
        }, CLOSE_DELAY);
      });

      var summary = d.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function (e) {
          /* A click right after hover-open keeps the menu open instead of closing it. */
          if (mq.matches && openedByHover && d.hasAttribute('open')) {
            e.preventDefault();
            openedByHover = false;
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
